import React from "react";
import brandLogo1 from "@/assets/providedassets/brandlogo1.jpeg";
import brandLogo2 from "@/assets/providedassets/brandlogo2.jpeg";
import brandLogo3 from "@/assets/providedassets/brandlogo3.jpeg";
import brandLogo4 from "@/assets/providedassets/brandlogo4.jpeg";

const CLIENTS = [
  { name: "JMD Furniture", logo: brandLogo1 },
  { name: "Venus Engineers", logo: brandLogo2 },
  { name: "Apex", logo: brandLogo3 },
  { name: "Shree Kalpavriksh Furnitures", logo: brandLogo4 },
];

export default function LogoCarousel() {
  return (
    <section className="border-b border-neutral-100 bg-white py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <p className="text-center text-sm font-semibold uppercase tracking-widest text-neutral-400">
          Trusted by retailers, manufacturers, interior designers, and home improvement brands
        </p>
        <div className="relative mt-8 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <div className="flex w-max animate-marquee items-center gap-16">
            {[...CLIENTS, ...CLIENTS].map((client, i) => (
              <div
                key={`${client.name}-${i}`}
                className="flex h-16 w-32 shrink-0 items-center justify-center rounded-lg border border-neutral-100 bg-white p-2"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
